import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, ArrowRight } from 'lucide-react';
import './NotFound.css'; // Import the CSS file

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-gray-100">
            <div className="glass-card p-8 md:p-12 max-w-2xl w-full text-center rounded-2xl shadow-lg">
                {/* Added this container to center content vertically */}
                <div className="flex flex-col justify-center h-full"> 
                    <div className="mb-8">
                        <div className="w-32 h-32 mx-auto mb-6 relative">
                            <div className="absolute inset-0 bg-gradient-to-r from-[#00BFA6] to-[#0288D1] rounded-full animate-pulse opacity-20"></div>
                            <div className="relative flex items-center justify-center h-full">
                                <span className="text-8xl font-bold gradient-text">404</span>
                            </div>
                        </div>
                        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">عذراً، الصفحة غير موجودة</h1>
                        <p className="text-gray-600 mb-8">
                            الصفحة التي تبحث عنها قد تكون غير موجودة أو تم نقلها إلى عنوان آخر
                        </p>
                    </div>

                    <div className="back-button-container">
                        <button
                            onClick={() => navigate('/')}
                            className="home-button"
                        >
                            <HomeIcon className="w-5 h-5" />
                            <span>العودة للرئيسية</span>
                        </button>

                        <button
                            onClick={() => navigate(-1)}
                            className="back-button"
                        >
                            <ArrowRight className="w-5 h-5" />
                            <span>الرجوع للصفحة السابقة</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;